
// Actions
const LOAD   = 'segments/LOAD';
const SAVE = 'segments/SAVE';
const CREATE = 'segments/CREATE';
const UPDATE = 'segments/UPDATE';
const REMOVE = 'segments/REMOVE';

// Reducer
export default function reducer(state = [], action = {}) {
  switch (action.type) {
    default: return state;
  }
}

// Action Creators
export function loadSegments() {
  return { type: LOAD };
}

export function saveSegment(data) {
  return { type: SAVE, data };
}

export function createSegment(data) {
  return { type: CREATE, data };
}

export function updateSegment(data) {
  return { type: UPDATE, data };
}

export function removeSegment(data) {
  return { type: REMOVE, data };
}

// side effects, only as applicable
// e.g. thunks, epics, etc
// export function getSegment () {
//   return dispatch => get('/data').then(data => dispatch(updateSegment(data)))
// }


// WEBPACK FOOTER //
// ./src/actions/segments.js